import { useCallback, useEffect, useState } from 'react';

export const useAutoDismissUpdateConfirmation = () => {
  const [shouldShowConfirmationBanner, setShowConfirmation] = useState<boolean>(false);

  useEffect(() => {
    if (shouldShowConfirmationBanner) {
      const timeoutId = setTimeout(() => {
        setShowConfirmation(false);
      }, 5000);

      return () => {
        clearTimeout(timeoutId);
      };
    }

    return () => {};
  }, [shouldShowConfirmationBanner]);

  const showConfirmationBanner = useCallback(() => {
    setShowConfirmation(true);
  }, []);

  return {
    shouldShowConfirmationBanner,
    showConfirmationBanner
  };
};
